import { useMutation } from 'react-query';
import { message } from 'antd';
import request from '../../../helpers/request';

const errorMessage = 'Не удалось изменить стадию помещения';

const mutationFn = ({ addressId, stageAddressLifeCycleId }) => {
  return request.put(
    'FlatsGrid/change_stage_address_life_cycle',
    { addressId, stageAddressLifeCycleId },
    errorMessage,
    'Error',
    undefined
  );
};

export const useChangeRoomStage = (options) => {
  return useMutation(mutationFn, {
    ...options,
    onSuccess: (data, variables) => {
      if (data === 'Error') {
        return;
      }

      if (typeof data.success === 'boolean' && data.success === false) {
        message.error(data.message ?? errorMessage);
        return;
      }

      if (typeof options?.onSuccess === 'function') {
        options.onSuccess(data, variables);
      }
    },
  });
};
